import { BusTopBg, BusBottomBg } from '@/assets/icons/bus/_';
import { SeatingType } from '@/constants';
import { range } from 'lodash';
import React from 'react';
import SeatDetail from './SeatDetail';
import './styles.less';
import BusMiddleBg from '@/assets/icons/bus/bus-middle-bg.png';
import { Spin } from 'antd';
import { CreateUpdateSeatingModelDetailModel, CompanyTicketClassDto, CreateUpdateSeatingModelModel } from '@/__generated';
import { apiSdk } from '@/httpClient';

const toDict = (arr: CreateUpdateSeatingModelDetailModel[]) => {
  let dict = {};
  arr.forEach(a => {
    dict[`${a.row}-${a.column}`] = a;
  });
  return dict;
};
const getNumberOfCol = (type: null) => {
  if (type === SeatingType['2X2 (5)']) {
    return 5;
  } else if (type === SeatingType['3X3 (7)']) {
    return 7;
  }
  return 6;
};
type Props = {
  seatingModelId: string;
  ticketClasses: CompanyTicketClassDto[];
};
export default function SeatingModel({ seatingModelId, ticketClasses }: Props) {
  const [seatingModelDetail, setSeatingModelDetail] = React.useState<CreateUpdateSeatingModelModel>();
  const [loading, setLoading] = React.useState<boolean>(false);
  React.useEffect(() => {
    if (seatingModelId) {
      setLoading(true);
      apiSdk.SeatingModelService.getEntityForUpdate({ id: seatingModelId })
        .then(res => {
          setSeatingModelDetail(res || undefined);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [seatingModelId]);
  const { numberOfRow, numberOfCol, seatsMap } = React.useMemo(() => {
    if (seatingModelDetail) {
      return {
        numberOfRow: seatingModelDetail.noOfRows || 0,
        numberOfCol: getNumberOfCol(seatingModelDetail.seatingType as any),
        seatsMap: toDict(seatingModelDetail.seatingModelDetails || []),
      };
    }
    return {
      numberOfRow: 0,
      numberOfCol: 0,
      seatsMap: {},
    };
  }, [seatingModelDetail]);
  return (
    <Spin spinning={loading}>
      <div id="seating-model">
        <div className="bus-model" id="bus-model">
          <div className="bus-header">
            <BusTopBg />
          </div>
          <div className="bus-container" style={{ backgroundImage: `url(${BusMiddleBg})` }}>
            <div className="seat-table">
              {range(0, numberOfRow).map(row => {
                return (
                  <div className="row" key={row}>
                    {range(0, numberOfCol).map(col => {
                      const key = `${row}-${col}`;
                      let data = seatsMap[key];

                      return <div className="col bus-seat-item">{data ? <SeatDetail seat={data} ticketClasses={ticketClasses} /> : null}</div>;
                    })}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="bus-footer">
            <BusBottomBg />
          </div>
        </div>
      </div>
    </Spin>
  );
}
